import type { CustomerCodeConfiguration, CustomerCodeConfigurationDraft } from '../models/customer-code-settings.model';
export interface PendingAutomaticCustomerCreate<T extends object = object> {
  requestId: string;
  payload: T;
  configuration?: CustomerCodeConfiguration;
}

/** An uncertain automatic create remains the same request even after runtime is disabled. */
export function prepareCustomerCodeCreate<T extends object>(input: T, enabled: boolean, requestId: string, pending?: PendingAutomaticCustomerCreate): T {
  if (!enabled && !pending) return input;
  const payload = {...pending?.payload, ...input, clientRequestId:pending?.requestId || requestId} as T & {code?:string;identityCode?:number;communeId?:string;villageId?:string};
  const original = pending?.payload as {communeId?:string;villageId?:string} | undefined;
  if (payload.communeId === undefined && original?.communeId !== undefined) payload.communeId = original.communeId;
  if (payload.villageId === undefined && original?.villageId !== undefined) payload.villageId = original.villageId;
  delete payload.code; delete payload.identityCode;
  return payload;
}

/** Detach from the transport's in-place normalization and later configuration edits. */
export function snapshotPendingCustomerCodeCreate<T extends object>(payload:T, requestId:string, configuration?:CustomerCodeConfiguration): PendingAutomaticCustomerCreate<T> {
  return JSON.parse(JSON.stringify({requestId,payload,configuration}));
}
export function availableCustomerCodeVillages(config: Pick<CustomerCodeConfigurationDraft,'villages'>, tollAreaId?: string) {
  return tollAreaId ? config.villages.filter(village => village.tollAreaIds.includes(tollAreaId)) : [];
}
export class CustomerCodeDraftSession {
  private submitting = false;
  constructor(public readonly requestId: string) {}
  begin() { if(this.submitting) return false; this.submitting=true; return true; }
  finish() { this.submitting=false; }
}
export const CUSTOMER_CODE_ACTIVATED_EVENT = 'waterms-customer-code-activated';
export const newCustomerCodeRequestId = () => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
};
